import React, { useState } from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react"
import { useForm } from "react-hook-form";

import SideModal from '/src/components/modal/SideModal/SideModal'
import useModalHelper from "/src/components/modal/hooks/useModalHelper";

import Form from "/src/components/form/Form";
import Field from '/src/components/UI/Field/Field';
import TextInput from '/src/components/UI/TextField/TextInput';
import TextArea from '/src/components/UI/TextField/TextArea';
import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import InputBox from "/src/components/UI/InputBox/InputBox";
import ButtonAction from "../../../../../components/UI/Button/Button";
import Slider, { Slide, ScrollIntoSlide } from '/src/components/slider/sliderView';
import checkKey from "/src/utils/checkKey";

import "/src/components/UI/TodoList/TodoList.css"
import "../StatementModal/StatementModal.css"
import "./StatementTestModal.css";
import StatementModalBody from "../StatementModal/StatementModalBody";
import statementService from "../../../services/statementService";
const StatementTestModal = NiceModal.create(({ dataset, data }) => {
    const modal = useModal();

    var title = 'Add your Statement';
    const { searchResponse } = statementService;
    const { onClose } = useModalHelper(modal);

    const [inputSearch, setInputSearch] = useState("");
    
    const [labels, setLabels] = useState("");
    const [match, setMatch] = useState("");
    const [responseData, setResponseData] = useState("");

    const openResponseSection = async () => {
        console.log(match)
        const [response, errors] = await searchResponse(dataset.name, { "question": inputSearch, "match":match, "labels" : labels })
        if (errors != null) {
            console.log(errors)
            return;
        }
        setResponseData(response);
    }

    const hideCloseButton = (bool) => {
        let element = document.getElementById("hide_close_button");
        element.style.opacity = bool ? "0" : "1";
        element.style.pointerEvents = bool ? "cursor" : "none"

    }

    return (
        <div name="test" onKeyUp={(e) => checkKey(e, 9)}>
            <SideModal name="change-password" id={modal.id} autoClose="true" onClose={onClose}>
                <div id="hide_close_button">
                    <div className="button-leave" id="close_modal_container" onClick={() => onClose({ idIconModal: "close_modal_container" })} >
                        <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                    </div>
                </div>
                <Slider className="slider-text_modal">
                    <Slide name="test-part">
                        <Form className="edit-container">
                            <Form.Title>Test your Statement</Form.Title>
                            <Form.Body className="body-editModal-container">
                                <Field label="Statement" />
                                <div className="raw">
                                    <TextInput placeholder="Tell me something" onKeyUp={(e) => { e.keyCode == "13" ? openResponseSection() : "" }} onChange={(e) => setInputSearch(e.target.value)} />
                                    <IconButton className="main-iconButton add-hover modalButtons-input" icon="fas fa-paper-plane sizeModal-icon" onClick={openResponseSection}></IconButton>
                                </div>
                                <Field label="Label" />
                                <div style={{ display: 'flex' }} >
                                    <div className="raw label-statement-container">
                                        <TextInput placeholder="Enter here" onChange={(e) => setLabels(e.target.value)} />
                                    </div>
                                    <div className="checkbox-statement">
                                        <Field label="Exact Match" listLabelClassName="labelTest" />
                                        <InputBox id="statement" classNameLabel="inputBox-center" onClick={(val) => setMatch(val)}></InputBox>
                                    </div>
                                </div>
                                {responseData ?
                                    <div className="responseSection">
                                        <Field listClassName="modal-bar bar_test-modal"></Field>
                                        <Field listClassName="name" label="Response"></Field>
                                        <div className="elements-container">
                                            <div className="response-elementSections">
                                                <Field label="Label"></Field>
                                                <TextInput value={responseData.label ? responseData.label : ""} disabled />
                                            </div>
                                            { /* 
                                            <div className="response-elementSections">
                                                <Field label="Feeling"></Field>
                                                <TextInput value={responseData.feeling ? responseData.feeling : ""} disabled />
                                            </div>
*/}
                                            <div className="response-elementSections">
                                                <Field label="Response"></Field>
                                                <TextArea value={responseData.response ? responseData.response : responseData.info} disabled />
                                            </div>
                                            {!responseData.label ?
                                                <div className="button_add_statement">
                                                    <ButtonAction className="cancel" label="Add New Statement" onClick={() => { ScrollIntoSlide('statement'); hideCloseButton(true) }}></ButtonAction>
                                                </div>
                                                : null
                                            }


                                        </div>

                                    </div>

                                    : null
                                } 
                            </Form.Body>

                        </Form>


                    </Slide>
                    <Slide name="statement">
                        <StatementModalBody dataset={dataset} title={title} is_button_back={true}></StatementModalBody>
                    </Slide>
                </Slider>
            </SideModal >
        </div>

    );
});

export default StatementTestModal;